import RenderStatusScreenBrick from './renderStatusScreenBrick'
import pixLoopStatus from './pixLoopStatus'
export default (bricksBuilder, store, validate) => async function () {
  let valid = await validate.$validate()
  console.log(Object.keys(store.getters.Profile).length)
  if(!valid && !Object.keys(store.getters.Profile).length) {
    store.dispatch('setClientValidate', validate)
    store.dispatch('LoadingPay', false)
    return
  }
  window.paymentBrickController.getFormData()
    .then( async ({ formData }) => {
      let freteValorMin = parseFloat(store.getters.Frete.valormin.replace('R$', '').replace(',', '.'))
      let CheckoutTotal01 = store.getters.CheckoutTotal01
      let SelectedClientEdit = store.getters.SelectedClientEdit
      let CheckoutItens01 = store.getters.CheckoutItens01
      let PedidoAtual = store.getters.PedidoAtual
      // callback chamado quando há click no botão de envio de dados
      if(PedidoAtual.length) {
        //usuario já logado, pedido já criado, apenas efetuar o pagamento
        let gift = await store.dispatch('GetGiftStore', { codigo: store.getters.cupom.codigo, usuario: SelectedClientEdit.usuario, itens: CheckoutItens01, pedidoid: PedidoAtual.id })
          .then(res => {
            return res
          })
        PedidoAtual.gift = gift.codigo
        PedidoAtual.giftvalor = gift.valor  
        PedidoAtual.valorTotal = freteValorMin > PedidoAtual.valorTotal ? PedidoAtual.valorTotal - gift.valor : (PedidoAtual.valorTotal + PedidoAtual.frete) - gift.valor
        store.dispatch('Payment', { payment: JSON.stringify(formData), pedido: PedidoAtual[0] })
          .then(pay => {
            if(pay.payment_method_id === 'pix') {
              pixLoopStatus(pay.id, store)
            }
            if(pay.status !== 'approved' && pay.status !== 'pending') {
              store.dispatch('SetTryAgainPay', true)
            }
            PedidoAtual[0].paymentid = pay.id
            PedidoAtual[0].status = 'Recebido'
            store.dispatch('SetPedidoAtual', PedidoAtual)
            // gravando no db o id do pagamento na tb_pedido
            store.dispatch('_UpdatePedido', PedidoAtual[0])
            store.dispatch('ViewPaymentMp', { comp: 'PaymentStatus', status: true })
            RenderStatusScreenBrick(bricksBuilder, pay.id, store)
            store.dispatch('LoadingPay', false)
          })
        return
      }
      if(Object.keys(store.state.System.Profile).length) {
        //usuario já logado, apenas criar o pedido e efetuar o pagamento
        store.dispatch('PushPedido', { dateCreate: new Date(), usuario: SelectedClientEdit.usuario, itens: CheckoutItens01, frete: freteValorMin > CheckoutTotal01 ? 0 : store.getters.ValorFrete, notas: store.getters.NotasPedido })
          .then( async pedido => {
            let gift = await store.dispatch('GetGiftStore', { codigo: store.getters.cupom.codigo, usuario: SelectedClientEdit.usuario, itens: CheckoutItens01, pedidoid: pedido.id })
              .then(res => {
                return res
              })
            pedido.gift = gift.codigo
            pedido.giftvalor = gift.valor  
            pedido.valorTotal = freteValorMin > pedido.valorTotal ? pedido.valorTotal - gift.valor : (pedido.valorTotal + pedido.frete) - gift.valor
            // setando o pedido atual
            store.dispatch('SetPedidoAtual', [pedido])
            // efetuando o pagamento
            store.dispatch('Payment', { payment: JSON.stringify(formData), pedido: pedido })
              .then(pay => {
                if(pay.payment_method_id === 'pix') {
                  pixLoopStatus(pay.id, store)
                }
                if(pay.status !== 'approved' && pay.status !== 'pending') {
                  store.dispatch('SetTryAgainPay', true)
                }
                pedido.paymentid = pay.id
                pedido.status = 'Recebido'
                store.dispatch('SetPedidoAtual', [pedido])
                // gravando no db o id do pagamento na tb_pedido
                store.dispatch('_UpdatePedido', pedido)
                RenderStatusScreenBrick(bricksBuilder, pay.id, store)
                store.dispatch('LoadingPay', false)
              })
          })
        return
      }
      return new Promise((resolve) => {
        //Criando o usuario, o pedido e efetuando o pagamento
        store.dispatch('PushClient', SelectedClientEdit)
          // criando o pedido
          .then(client => store.dispatch('PushPedido', { dateCreate: new Date(), usuario: client, itens: CheckoutItens01, frete: freteValorMin > CheckoutTotal01 ? 0 : store.getters.ValorFrete, notas: store.getters.NotasPedido }))
          .then(async pedido => {
            let gift = await store.dispatch('GetGiftStore', { codigo: store.getters.cupom.codigo, usuario: SelectedClientEdit.usuario, itens: CheckoutItens01, pedidoid: pedido.id })
              .then(res => {
                return res
              })
            pedido.gift = gift.codigo
            pedido.giftvalor = gift.valor
            pedido.valorTotal = freteValorMin > pedido.valorTotal ? pedido.valorTotal - gift.valor : (pedido.valorTotal + pedido.frete) - gift.valor
            // setando o pedido atual
            store.dispatch('SetPedidoAtual', [pedido])
            // efetuando o pagamento
            store.dispatch('Payment', { payment: JSON.stringify(formData), pedido: pedido })
              .then(pay => {
                if(pay.payment_method_id === 'pix') {
                  pixLoopStatus(pay.id, store)
                }
                if(pay.status !== 'approved' && pay.status !== 'pending') {
                  store.dispatch('SetTryAgainPay', true)
                }
                pedido.paymentid = pay.id
                pedido.status = 'Recebido'
                store.dispatch('SetPedidoAtual', [pedido])
                // gravando no db o id do pagamento na tb_pedido
                store.dispatch('_UpdatePedido', pedido)
                RenderStatusScreenBrick(bricksBuilder, pay.id, store)
                store.dispatch('LoadingPay', false)
              })
          })
        resolve()
      })
    })
}
